import React, { Component } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AdmissionApi from "../../../Services/AdmissionApi";
import Paging from "../../Paging";
import "./style.css";

class AdminAdmissionAlerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: false,
      alerts: [],
      page: 1,
      pageSize: 6,
      totalPages: 1,
      institutionName: '',
      selectedCategory: '',
      lastApplyFrom: '',
      lastApplyTo: '',
      allCategories: []
    };
    this.handleState = this.handleState.bind(this);
    this.updateListData = this.updateListData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.deleteAlert = this.deleteAlert.bind(this);

    this.admissionsService = new AdmissionApi();
  }

  handleState(value, data) {
    this.setState({
      detail: value,
    });

    this.props.sendDetail(value, data);
  }

  updateState = (newResponse) => {
    this.setState({
      totalPages: newResponse.data.pageCount,
      page: newResponse.data.page,
      alerts: newResponse.data._embedded.admissionalerts
    });
  };

  componentDidMount() {
    this.getData();
    this.getAllCategories();
  }

  cbCourseCategories = (newResponse) => {
    if (newResponse.data.success) {
      const _categories = newResponse.data._embedded.category

      const allCategories = _categories.map((item, i) => ({
        label: item.name,
        value: item.id,
        tagColor: `hsl(${300 + i * 50}deg 36% 84%)`
      }))

      this.setState({ allCategories });
    }
  }

  getAllCategories = () => {
    this.admissionsService.GetData(
      this.cbCourseCategories,
      "v1/students/alert/category"
    )
  }

  getData(page = 1) {

    let filters = ''
    const {
      institutionName,
      selectedCategory,
      lastApplyFrom,
      lastApplyTo,
      pageSize
    } = this.state

    if (institutionName) filters += `&institution_name=${institutionName}`
    if (lastApplyFrom) filters += `&last_date_to_apply_from=${lastApplyFrom}`
    if (lastApplyTo) filters += `&last_date_to_apply_to=${lastApplyTo}`
    if (selectedCategory) filters += `&course_category_id=${selectedCategory}`

    this.admissionsService.GetData(
      this.updateState,
      `v1/alerts/admissionalerts?page=${page}&pageSize=${pageSize}&column=created_at&order=desc${filters}`
    )
  }

  updateListData = (data) => {
    if (data) {
      this.updateState(data);
    } else {
      this.getData();
    }
  };

  getCourse = (data) => {
    let _data = JSON.parse(data)
    return Object.values(_data)
  }

  deleteState = (newResponse) => {
    this.handlePageChange(this.state.page);
  };

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = (e) => {
    e.preventDefault()
    this.getData()
  }

  clearFilter = () => {
    this.setState({
      institutionName: '',
      selectedCategory: '',
      lastApplyFrom: '',
      lastApplyTo: '',
    }, this.getData)
  }

  handlePageChange = (page) => {
    this.getData(page)
  }

  deleteAlert = (alert) => {
    confirmAlert({
      title: "Confirm ?",
      message: "Are You Sure you want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.admissionsService.deleteCredentials(
              this.deleteState,
              "v1/alerts/admissionalerts",
              alert.id
            );
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    const {
      alerts,
      page,
      totalPages,
      institutionName,
      selectedCategory,
      lastApplyFrom,
      lastApplyTo,
      allCategories
    } = this.state

    const { showDetails } = this.props

    return (
      <section className="dash-alerts">
        <form>
          <div className="alert-filter">
            <div className="form-group mr-2 mb-0">
              <label>Institution</label>
              <input
                type="text"
                id="institutionName"
                className="form-control alert-filter__input"
                placeholder="Institution Name"
                value={institutionName}
                onChange={this.handleFilterInputChange}
              />
            </div>
            <div className="form-group mr-2 mb-0">
              <label>Category</label>
              <select
                className="form-control alert-filter__input"
                id="selectedCategory"
                value={selectedCategory}
                onChange={this.handleFilterInputChange}
              >
                <option value="">Choose...</option>
                {allCategories.map(item => (
                  <option key={item.value} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
            <div className="form-group mr-2 mb-0">
              <label>Last Apply From</label>
              <input
                type="date"
                id="lastApplyFrom"
                value={lastApplyFrom}
                onChange={this.handleFilterInputChange}
                className="form-control alert-filter__input"
              />
            </div>
            <div className="form-group mr-2 mb-0">
              <label>Last Apply To</label>
              <input
                type="date"
                id="lastApplyTo"
                value={lastApplyTo}
                onChange={this.handleFilterInputChange}
                className="form-control alert-filter__input"
              />
            </div>
            <button
              className="btn btn--primary align-self-end"
              onClick={this.filterList}
            >
              Submit
            </button>
            <button
              className="btn btn--default align-self-end ml-2"
              onClick={this.clearFilter}
            >
              Clear
            </button>
          </div>
        </form>
        <table className="table table-responsive alert-table">
          <thead>
            <tr>
              <th scope="col">
                Institution
              </th>
              <th scope="col">Last date to apply</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {alerts.map(item => (
              <tr key={item.id}>
                <td>
                  <p style={{ fontWeight: 'bold' }} className="m-0">{item.subject_line}</p>
                  <p style={{ color: '#2c2c2c' }} className="m-0">{item.institution_name}</p>
                  {this.getCourse(item.course_category_id).map((item, i) => (
                    <span
                      key={i}
                      className="badge mr-2 mb-1"
                      style={{ backgroundColor: allCategories.reduce((r, o) => o.label === item ? o.tagColor : r, '') }}
                    >
                      {item}
                    </span>
                  ))}
                </td>
                <td>{item.last_date_online}</td>
                <td className="d-flex">
                  <button className="btn btn-link alert-table__link" onClick={() => showDetails('admn-alert-details', item)}>
                    <i className="icon-eye" />
                  </button>
                  <button className="btn btn-link alert-table__link" onClick={() => this.deleteAlert(item)}>
                    <i className="icon-trash" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />
      </section>
    )
  }
}

export default AdminAdmissionAlerts



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminAdmissionAlerts/index.js
 **/